export enum UintListUpdateType {
  None = '0',
  AddOnly = '1',
  RemoveOnly = '2',
  AddAndRemove = '3',
}
